import { Col, Row, Typography } from "@codat/orchard-ui";
import classNames from "classnames";
import React from "react";

import GettingStarted from "../../components/GettingStarted";
import styles from "./Home.module.scss";

export const IntroductionContentOld = (props: {
  userCanViewAPIKeys: boolean;
}) => {
  const { userCanViewAPIKeys } = props;
  return (
    <>
      <Row className={classNames(styles.row, styles.dashboardHeadingRow)}>
        <Col size={12} className={styles.column}>
          <Typography
            as="h2"
            variant="heading_lg"
            className={styles.subHeading}
          >
            Getting started
          </Typography>
        </Col>
      </Row>
      <Row collapseMargin>
        <Col size={4}>
          <GettingStarted
            card="gettingStarted"
            hasAPIKeyViewPermission={userCanViewAPIKeys}
          />
        </Col>
        <Col size={4}>
          <GettingStarted
            card="addCompany"
            hasAPIKeyViewPermission={userCanViewAPIKeys}
          />
        </Col>
        <Col size={4}>
          <GettingStarted
            card="apiAccess"
            hasAPIKeyViewPermission={userCanViewAPIKeys}
          />
        </Col>
      </Row>
    </>
  );
};
